
import { tracs_api } from "../../services/api.interceptor";

class SettingsService{
    gettocs(){
        return tracs_api
        .post(process.env.REACT_APP_USER_API + "Settings/GetTocs");
    }

    getenvtypes(){
        return tracs_api
        .post(process.env.REACT_APP_USER_API + "Settings/GetEnvironmentTypes");
    }

    getdatabases(tocId:string|null|undefined,envTypeId:string|null|undefined){
        return tracs_api
        .post(process.env.REACT_APP_USER_API + "Settings/GetDatabases",{TocId:tocId,EnvironmentTypeId:envTypeId});
    }

    getSystemInfo(){
        return tracs_api
        .post(process.env.REACT_APP_USER_API + "Settings/GetSystemInfo")
    }

    }



export default new SettingsService();